import React from 'react';
import { pure } from 'recompose';
import './Usergroup.css';
import ToolFilterText from '../../containers/ToolFilterText';

export default pure(({ selected, user, nodata, filter, activity,
  startVideo, endVideo, metrics, memory, battery, report, onClick,
}) => {
  const renderInfo = () => (
    <div className="info">
      <span>
        {startVideo && <span className="fontawesome-film" />}
        <span>{(startVideo) && ` ${startVideo}-${endVideo}`}</span>
        {/* <span>{metrics}{' '}</span> */}
        {memory && <span className="fontawesome-save" />}
        <span>{' '}{memory}</span>
      </span>
      <div className="activity">{metrics.length > 0 ? metrics : activity}</div>
    </div>
  );

  const renderReport = () => (
    <span className="report">
      <span style={{ marginRight: 2 }}>{report}</span>
      <span className="fontawesome-list-alt" />
    </span>
  );

  const renderBattery = () => (
    <span className="battery">
      <span className="fontawesome-bolt" />
      {battery}
    </span>
  );

  return (
    <div
      className={`item${selected ? ' selected' : ''}`}
      onClick={onClick}
    >
      <div className="icon" />
      <div className="body">
        <div className="title">
          <div className="name">
            <span className="fontawesome-user" />
            <span style={{ margin: 2 }} />
            <ToolFilterText text={user.name.replace(user.id, '')} filter={filter} />
          </div>
          {report ? renderReport() : (battery && renderBattery())}
        </div>
        <div>
          {nodata
            ? <span className="nodata">{nodata}</span>
            : renderInfo()
          }
        </div>
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/Usergroup/UsergroupItem.jsx